<div
  class="absolute top-0 right-0 bottom-0 left-0"
  #ocrOverlayContainer
  [ngClass]="{
    'cursor-crosshair': isTableCreationToggled(),
  }"></div>

@let _dimension = dimension();
@if (_dimension) {
  <ct-extraction-text-selection-overlay
    [selectedWordsRect]="selectedWordRects()"
    [lasso]="boxSelection.currentLasso()"
    [dimension]="_dimension"
    [highlight]="highlight()"
    [showTextSelectionOverlay]="!isTableCreationToggled()"
    (changeAutoUpdate)="enableAutoUpdate.set($event)" />
  @if (showFieldExtractionOverlay()) {
    <ct-extraction-field-extraction-overlay
      [dimension]="_dimension"
      [rect]="highlight() === undefined ? undefined : highlight()!.selection[0][0]"
      [currentActiveFieldModel]="currentFieldService.currentActiveFieldModel"
      [currentDocumentId]="selectedDocumentId()"
      [extractionPage]="currentFieldService.extractionPage"
      [formGroups]="dynamicFormService.formGroups"
      [isExpanded]="isFieldExtractionOverlayCollapsed()"
      [isTableExtraction]="this.tableExtractionSectionsOnCurrentPage().length > 0"
      [enableAutoUpdate]="enableAutoUpdate()"
      (nextField)="currentFieldService.focusNextField()"
      (fieldExtractionOverlayToggle)="fieldExtractionOverlayToggle.emit($event)" />
  }

  @if (shouldDisplayTableOverlay()) {
    @for (table of tableCollection(); track table.id) {
      <ct-extraction-table-overlay
        #tableOverlayComponent
        [page]="page()"
        [isTableCreationToggled]="isTableCreationToggled()"
        [tableData]="table"
        [type]="isCurrentPageRowClassification() ? 'table-row-classification' : 'table-extraction'"
        (deleteTable)="deleteTable($event)"
        (update)="updateTableData($event)" />
    }

    @if (isTableCreationToggled()) {
      <ct-extraction-table-creation-overlay
        [dimension]="_dimension"
        [currentLasso]="boxSelection.currentLasso()" />
    }
  }
}
